import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurMassachusetts = () => (
  <SEOPageTemplate
    city="Massachusetts"
    state="MA"
    route="/chauffeur-massachusetts"
    imageSrc="/massachusetts-limo.jpg"
    introduction="Experience premium chauffeur services across Massachusetts with TiLimousine. From the historic streets of Boston to the scenic Cape Cod, we provide luxury transportation solutions for every occasion. Our professional chauffeurs ensure safe, comfortable, and punctual service throughout the Bay State, whether you need airport transfers, corporate travel, or special event transportation."
    testimonial={{
      quote: "TiLimousine has been our trusted transportation partner for all our executive travel needs in Massachusetts. Their attention to detail and commitment to service excellence is unmatched. The chauffeurs are always professional, punctual, and knowledgeable about the best routes.",
      author: "Michael Chen",
      role: "Operations Director"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Boston ⇄ NYC, Boston ⇄ DC',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Massachusetts',
      'Best chauffeur in Massachusetts',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Massachusetts',
      'Best executive car service in Massachusetts',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Logan International Airport (BOS)',
      'Worcester Regional Airport',
      'Hanscom Field',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Rectrix',
      'Teterboro',
      'JFK',
      'LGA',
      'DCA'
    ]}
    neighborhoods={[
      'Boston',
      'Cambridge',
      'Worcester',
      'Springfield',
      'Cape Cod',
      'Greater Boston Area'
    ]}
  />
);

export default ChauffeurMassachusetts; 